import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { removeItemFromCart } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isCheckoutPrintLocationWarningsPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { openEditDialog } from '../../../redux/cart/cart.actions';
import { isCartItemsLogoEmptySelector, isSomeItemPrintLocationRemovedSelector, cartItemsWithEmptyLogosSelector, cartItemsWithRemovedPrintLocationsSelector } from '../../../redux/cart/cart.selectors';
const contentTextSelector = createSelector(isSomeItemPrintLocationRemovedSelector, isCartItemsLogoEmptySelector, (isSomeItemPrintLocationRemoved, isCartItemsLogoEmpty) => {
  switch (true) {
    case isCartItemsLogoEmpty:
      {
        return 'Please upload your logo in order to proceed';
      }
    case isSomeItemPrintLocationRemoved:
      {
        return 'Some Print Locations removed';
      }
    default:
      {
        return '';
      }
  }
});
const headerTextSelector = createSelector(isSomeItemPrintLocationRemovedSelector, isCartItemsLogoEmptySelector, (isSomeItemPrintLocationRemoved, isCartItemsLogoEmpty) => {
  switch (true) {
    case isCartItemsLogoEmpty:
      {
        return 'You need to upload a design';
      }
    case isSomeItemPrintLocationRemoved:
      {
        return 'Some Print Locations removed';
      }
    default:
      {
        return '';
      }
  }
});
const itemsWithWarningSelector = createSelector(cartItemsWithEmptyLogosSelector, cartItemsWithRemovedPrintLocationsSelector, (emptyItems, logosRemovedItems) => {
  switch (true) {
    case !!emptyItems.length:
      {
        return emptyItems;
      }
    case !!logosRemovedItems.length:
      {
        return logosRemovedItems;
      }
    default:
      {
        return [];
      }
  }
});
import CheckoutPrintLocationWarningsPopupComponent from './checkout-print-location-warnings-popup';
const mapStateToProps = createStructuredSelector({
  headerText: headerTextSelector,
  contentText: contentTextSelector,
  items: itemsWithWarningSelector,
  isOpen: isCheckoutPrintLocationWarningsPopupShownSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  },
  onRemoveItem: id => {
    dispatch(removeItemFromCart({
      id
    }));
  },
  onEditRequest: item => {
    dispatch(openEditDialog(item, OrderStorageTypes.CART));
  }
});
export const CheckoutPrintLocationRemovedPopup = connect(mapStateToProps, mapDispatchToProps)(CheckoutPrintLocationWarningsPopupComponent);